import type { RedirectError } from 'src/types/redirectError';

interface RedirectParams {
  redirectUrl: string;
  state?: string | null;
}

const redirect = (
  urlString: string,
  searchParams: Record<string, string>,
): null => {
  const url = new window.URL(urlString);

  for (const [name, value] of Object.entries(searchParams)) {
    url.searchParams.set(name, value);
  }

  window.location.assign(url.toString());

  return null;
};

export const redirectWithCode = (
  { state, redirectUrl }: RedirectParams,
  code: string,
): null =>
  redirect(redirectUrl, {
    code,
    ...(state && { state }),
  });

export const redirectWithError = (
  { state, redirectUrl }: RedirectParams,
  error: RedirectError,
): null =>
  redirect(redirectUrl, {
    error,
    ...(state && { state }),
  });
